import { createSlice } from '@reduxjs/toolkit'
import { userLoggedOut } from 'core/session/slices/session'
import { SchedulesState } from './types'

const initialState: SchedulesState = {}

const eventDetailsSchedulesSlice = createSlice({
  name: 'virtualClassroomManagerEventDetailsSchedules',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

export default eventDetailsSchedulesSlice.reducer
